import { useSnackbar } from 'notistack'
import { useContext, useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AddEditAdUnitContext } from 'features/inventory/ad-unit/contexts/AddEditAdUnitContext'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { mapGraphQLErrors } from 'providers/tanstack-query/utils'
import { Schema } from '../schema'
import { toDTO } from './api/mapper'
import { UPDATE_AD_UNIT_REFRESHER } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdateAdUnitRefresher } from './types'

export const useUpdateAdUnitRefresher = (): UseUpdateAdUnitRefresher => {
  const { t } = useTranslation('features/adUnit')
  const { enqueueSnackbar } = useSnackbar()
  const { setLoading } = useContext(AddEditAdUnitContext)
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_AD_UNIT_REFRESHER,
    onCompleted: async (data: Data) => {
      const {
        updateAdUnitRefresher: { errors },
      } = data

      setLoading(false)

      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('form.error.update'), { variant: 'error' })
      } else {
        setErrors({})
        enqueueSnackbar(t('form.success.update'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['adUnit'],
  })

  const update = (schema: Schema): void => {
    setLoading(true)

    mutateAsync({
      input: toDTO(schema),
    })
  }

  return { errors, update }
}
